module.exports = __webpack_public_path__ + "img/karafarin.32564fa9.png";